// Arabic translations
export const ar = {
  // Common
  brandName: "VAROTRADES Inc",
  login: "تسجيل الدخول",
  register: "إنشاء حساب",
  logout: "تسجيل الخروج",
  dashboard: "لوحة التحكم",
  settings: "الإعدادات",
  adminPanel: "لوحة الإدارة",
  search: "بحث",
  viewAll: "عرض الكل",
  learnMore: "اعرف المزيد",
  getStarted: "ابدأ الآن",
  downloadApp: "تحميل التطبيق",
  
  // Navigation
  nav: {
    trade: "التداول",
    markets: "الأسواق",
    earn: "الربح",
    learn: "التعلم",
    more: "المزيد",
    spotTrading: "التداول الفوري",
    spotTradingDesc: "شراء وبيع أكثر من 2000 عملة رقمية",
    futures: "العقود الآجلة",
    futuresDesc: "تداول برافعة تصل إلى 125x",
    marginTrading: "التداول بالهامش",
    marginTradingDesc: "ضاعف قوتك التداولية",
    copyTrading: "نسخ التداول",
    copyTradingDesc: "تابع أفضل المتداولين تلقائياً",
    tradingBots: "روبوت التداول",
    tradingBotsDesc: "أتمتة استراتيجياتك 24/7",
    p2pTrading: "تداول P2P",
    p2pTradingDesc: "تداول مباشر مع الآخرين",
    marketOverview: "نظرة على السوق",
    marketOverviewDesc: "جميع الأسواق والأسعار",
    cryptocurrencies: "العملات الرقمية",
    cryptocurrenciesDesc: "BTC, ETH وأكثر من 2000 عملة",
    newListings: "إدراجات جديدة",
    newListingsDesc: "أحدث العملات المضافة",
    topGainers: "الأكثر ربحاً",
    topGainersDesc: "أفضل الأداء اليوم",
    simpleEarn: "Simple Earn",
    simpleEarnDesc: "ادخار مرن يصل إلى 12% APY",
    staking: "الستيكينغ",
    stakingDesc: "قفل واربح مكافآت",
    launchpool: "Launchpool",
    launchpoolDesc: "زراعة عملات جديدة",
    hodlerAirdrops: "HODLer Airdrops",
    hodlerAirdropsDesc: "مكافآت للحاملين",
    cryptoAcademy: "أكاديمية الكريبتو",
    cryptoAcademyDesc: "دورات لجميع المستويات",
    videoTutorials: "دروس فيديو",
    videoTutorialsDesc: "شروحات خطوة بخطوة",
    articlesGuides: "مقالات ودلائل",
    articlesGuidesDesc: "معرفة معمقة",
    helpCenter: "مركز المساعدة",
    helpCenterDesc: "الأسئلة والدعم",
    aboutUs: "من نحن",
    aboutUsDesc: "قصتنا ورسالتنا",
    security: "الأمان",
    securityDesc: "كيف نحميك",
    proofOfReserves: "إثبات الاحتياطي",
    proofOfReservesDesc: "شفافية 100%",
    careers: "وظائف",
    careersDesc: "انضم لفريقنا",
  },
  
  // Hero Section
  hero: {
    title1: "بوابتك إلى عالم",
    title2: "العملات الرقمية",
    subtitle: "الخيار الموثوق لأكثر من",
    traders: "49 مليون",
    tradersText: "متداول",
    continueWith: "أو تابع مع",
  },
  
  // Stats
  stats: {
    volume24h: "حجم التداول 24 ساعة",
    cryptocurrencies: "عملة رقمية",
    simpleEarnApy: "عائد Simple Earn",
    reserveRatio: "نسبة الاحتياطي",
  },
  
  // Products
  products: {
    title: "تداول في أي مكان وزمان",
    subtitle: "منتجات متنوعة تناسب جميع استراتيجيات التداول",
    spotTrading: "التداول الفوري",
    spotDesc: "أكثر من 2000 زوج",
    futures: "العقود الآجلة",
    futuresDesc: "رافعة حتى 125x",
    copyTrading: "نسخ التداول",
    copyDesc: "تابع الخبراء",
    tradingBots: "روبوت التداول",
    botsDesc: "تداول آلي 24/7",
    simpleEarn: "Simple Earn",
    earnDesc: "عوائد مرنة",
    launchpool: "Launchpool",
    launchDesc: "عملات جديدة",
    popular: "شائع",
    hot: "عالي الطلب",
    easy: "سهل",
    smart: "ذكي",
    earn: "ربح",
    exclusive: "حصري",
  },
  
  // How to Start
  howToStart: {
    title: "كيف تبدأ",
    step1Title: "إنشاء حساب",
    step1Desc: "سجّل واحصل على مكافآت ترحيبية حصرية",
    step2Title: "الشراء السريع",
    step2Desc: "اشترِ العملات بخطوات بسيطة وسهلة",
    step3Title: "ابدأ التداول",
    step3Desc: "تداول، انسخ الصفقات، واربح المزيد",
    welcomeBonus: "مكافأة الترحيب",
    forNewUsers: "للمستخدمين الجدد",
  },
  
  // Security
  security: {
    title: "نحمي كل صفقة",
    subtitle: "أمان متعدد الطبقات لحماية أصولك",
    advancedSecurity: "أمان متقدم",
    advancedSecurityDesc: "عقود ذكية مدققة ومراقبة على السلسلة تمنع الثغرات",
    proofOfReserves: "إثبات الاحتياطي",
    proofOfReservesDesc: "أول منصة تقدم احتياطي 100% مع تدقيق شفاف",
    secureStorage: "تخزين آمن",
    secureStorageDesc: "تخزين استراتيجي في محافظ باردة لحماية الأصول",
  },
  
  // CTA
  cta: {
    title: "ابدأ رحلتك الآن",
    subtitle: "انضم إلى ملايين المتداولين حول العالم واستمتع بتجربة تداول آمنة وموثوقة",
    createAccount: "إنشاء حساب مجاني",
    exploreMarkets: "استكشف الأسواق",
  },
  
  // Footer
  footer: {
    products: "المنتجات",
    services: "الخدمات",
    support: "الدعم",
    company: "الشركة",
    legal: "قانوني",
    description: "منصة تداول عالمية موثوقة من ملايين المستخدمين. تداول بأمان وشفافية.",
    downloadApp: "حمّل التطبيق",
    sslEncrypted: "تشفير SSL",
    reserves: "احتياطي",
    securityAudited: "تدقيق أمني",
    allRightsReserved: "جميع الحقوق محفوظة",
    riskWarning: "تحذير: تداول العملات الرقمية ينطوي على مخاطر عالية. تأكد من فهمك للمخاطر قبل التداول.",
    termsOfService: "شروط الاستخدام",
    privacyPolicy: "سياسة الخصوصية",
    riskDisclosure: "تحذير المخاطر",
    amlPolicy: "سياسة AML",
    helpCenter: "مركز المساعدة",
    faq: "الأسئلة الشائعة",
    fees: "الرسوم",
    apiDocs: "API",
    submitRequest: "تقديم طلب",
    aboutVAROTRADES: "عن VAROTRADES",
    news: "الأخبار",
    partnerships: "الشراكات",
    buyCrypto: "شراء العملات",
  },
  
  // Promo Banner
  promo: {
    signUpNow: "سجل الآن واحصل على",
    upTo: "حتى",
    inRewards: "مكافآت",
  },
  
  // Price Card
  priceCard: {
    hot: "الأكثر تداولاً",
    new: "جديد",
    gainers: "الرابحون",
  },
  
  // Partners
  partners: {
    officialPartner: "الشريك الرسمي:",
  },
  
  // Login Page
  loginPage: {
    title: "تسجيل الدخول",
    welcome: "مرحباً بعودتك إلى VAROTRADES",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    forgotPassword: "نسيت كلمة المرور؟",
    loggingIn: "جارٍ تسجيل الدخول...",
    continueWith: "أو تابع مع",
    noAccount: "ليس لديك حساب؟",
    registerNow: "سجل الآن",
    demoAccount: "حساب تجريبي:",
    invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    twoFactorTitle: "التحقق بخطوتين",
    twoFactorDesc: "أدخل الرمز من تطبيق المصادقة",
    verify: "تأكيد",
    goBack: "العودة",
    invalidCode: "رمز التحقق غير صحيح",
  },
  
  // Register Page
  registerPage: {
    title: "إنشاء حساب",
    subtitle: "انضم إلى VAROTRADES اليوم",
    welcomeBonus: "مكافأة ترحيبية $100",
    bonusDesc: "سجل الآن واحصل على مكافأتك",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    confirmPassword: "تأكيد كلمة المرور",
    agreeToTerms: "أوافق على",
    termsOfService: "شروط الاستخدام",
    and: "و",
    privacyPolicy: "سياسة الخصوصية",
    creatingAccount: "جارٍ إنشاء الحساب...",
    createAccount: "إنشاء الحساب",
    registerWith: "أو سجل مع",
    haveAccount: "لديك حساب بالفعل؟",
    mustAgree: "يجب الموافقة على الشروط والأحكام",
    passwordMismatch: "كلمات المرور غير متطابقة",
    passwordLength: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
    accountFailed: "فشل في إنشاء الحساب",
  },
  
  // Markets Page
  marketsPage: {
    title: "الأسواق",
    subtitle: "تتبع الأسعار والقيم السوقية وأحجام التداول",
    totalMarketCap: "القيمة السوقية الكلية",
    volume24h: "حجم 24 ساعة",
    btcDominance: "هيمنة BTC",
    activeCryptos: "العملات النشطة",
    all: "الكل",
    hot: "ساخن",
    newListings: "إدراجات جديدة",
    topGainers: "الأكثر ربحاً",
    topLosers: "الأكثر خسارة",
    searchCoins: "بحث العملات...",
    filter: "تصفية",
    name: "الاسم",
    price: "السعر",
    change24h: "التغيير 24س",
    volume: "الحجم",
    action: "إجراء",
    trade: "تداول",
    loadMore: "تحميل المزيد",
    readyToTrade: "هل أنت جاهز للتداول؟",
    joinMillions: "انضم إلى ملايين المتداولين وابدأ رحلتك في الكريبتو اليوم",
  },
  
  // Learn Page
  learnPage: {
    title: "تعلم",
    titleHighlight: "الكريبتو",
    titleEnd: "التداول",
    subtitle: "دورات مجانية ودروس ودلائل لإتقان تداول العملات الرقمية",
    searchPlaceholder: "بحث في الدورات والمقالات والفيديوهات...",
    all: "الكل",
    beginner: "مبتدئ",
    trading: "تداول",
    security: "أمان",
    defi: "DeFi",
    featuredCourses: "الدورات المميزة",
    viewAll: "عرض الكل",
    videoTutorials: "دروس الفيديو",
    articlesGuides: "مقالات ودلائل",
    faq: "الأسئلة الشائعة",
    faqSubtitle: "إجابات سريعة على الأسئلة الشائعة",
    viewAllFaqs: "عرض جميع الأسئلة",
    readyToPractice: "هل أنت جاهز لتطبيق ما تعلمته؟",
    startTradingConfidence: "ابدأ التداول بثقة باستخدام ما تعلمته",
    startTradingNow: "ابدأ التداول الآن",
    lessons: "درس",
    views: "مشاهدة",
    minRead: "دقيقة قراءة",
  },
  
  // Company Page
  companyPage: {
    title: "عن",
    titleHighlight: "VAROTRADES",
    subtitle: "بناء مستقبل التمويل من خلال جعل العملات الرقمية متاحة وآمنة وبسيطة للجميع.",
    registeredUsers: "مستخدم مسجل",
    countriesServed: "دولة",
    dailyVolume: "حجم التداول اليومي",
    cryptocurrencies: "عملة رقمية",
    ourStory: "قصتنا",
    ourStoryP1: "تأسست VAROTRADES في 2017 بمهمة بسيطة: جعل تداول العملات الرقمية متاحاً للجميع، بغض النظر عن مستوى خبرتهم أو موقعهم.",
    ourStoryP2: "ما بدأ كفريق صغير من عشاق الكريبتو المتحمسين نما ليصبح منصة عالمية تخدم ملايين المستخدمين في أكثر من 160 دولة.",
    ourStoryP3: "اليوم، نفتخر بكوننا واحدة من أبرز منصات تداول العملات الرقمية في العالم، موثوقة من المتداولين والمستثمرين في جميع أنحاء العالم.",
    ourValues: "قيمنا",
    ourValuesSubtitle: "المبادئ التي توجه كل ما نفعله",
    securityFirst: "الأمان أولاً",
    securityFirstDesc: "نعطي الأولوية لسلامة أصول مستخدمينا بتدابير أمنية رائدة.",
    userCentric: "التركيز على المستخدم",
    userCentricDesc: "كل قرار نتخذه مدفوع بما هو الأفضل لمستخدمينا.",
    innovation: "الابتكار",
    innovationDesc: "نتخطى الحدود باستمرار لتقديم حلول تداول متطورة.",
    globalAccess: "وصول عالمي",
    globalAccessDesc: "جعل العملات الرقمية متاحة للجميع، في كل مكان.",
    securityTrust: "الأمان والثقة",
    securityTrustSubtitle: "أمانك هو أولويتنا القصوى",
    proofOfReserves: "إثبات الاحتياطي",
    proofOfReservesDesc: "100% من أصول المستخدمين مدعومة وقابلة للتحقق على السلسلة في أي وقت.",
    coldStorage: "التخزين البارد",
    coldStorageDesc: "غالبية الأصول مخزنة في محافظ باردة آمنة وغير متصلة.",
    regularAudits: "تدقيقات منتظمة",
    regularAuditsDesc: "تدقيقات أمنية من طرف ثالث تضمن أن أنظمتنا تلبي أعلى المعايير.",
    insuranceFund: "صندوق التأمين",
    insuranceFundDesc: "صندوق مخصص لحماية المستخدمين من الظروف غير المتوقعة.",
    leadershipTeam: "فريق القيادة",
    leadershipSubtitle: "تعرف على الأشخاص الذين يقودون مهمتنا",
    globalPresence: "التواجد العالمي",
    globalPresenceSubtitle: "خدمة المستخدمين في جميع أنحاء العالم مع دعم إقليمي",
    joinOurTeam: "انضم لفريقنا",
    joinTeamDesc: "نبحث دائماً عن أفراد موهوبين يشاركوننا شغفنا بالعملات الرقمية والابتكار. استكشف الوظائف المتاحة وانضم لعائلة VAROTRADES.",
    viewOpenPositions: "عرض الوظائف المتاحة",
    teamMembers: "عضو فريق",
    countries: "دولة",
    openRoles: "وظيفة متاحة",
    remoteFriendly: "صديق للعمل عن بعد",
    getInTouch: "تواصل معنا",
    getInTouchSubtitle: "هل لديك أسئلة؟ نحن هنا للمساعدة",
    emailUs: "راسلنا",
  },
  
  // Chat Widget
  chat: {
    title: "مساعد VAROTRADES",
    online: "متصل",
    welcomeMessage: "مرحباً! 👋 أنا مساعدك الذكي في VAROTRADES.\n\nكيف يمكنني مساعدتك اليوم؟",
    placeholder: "اكتب رسالتك...",
    poweredBy: "مدعوم بالذكاء الاصطناعي",
    instantSupport: "مساعدة فورية 24/7",
    newChat: "محادثة جديدة",
    errorMessage: "عذراً، حدث خطأ. يرجى المحاولة مرة أخرى.",
    connectionError: "عذراً، حدث خطأ في الاتصال. يرجى المحاولة لاحقاً.",
    quickQuestion1: "كيف أبدأ التداول؟",
    quickQuestion2: "ما هي الرسوم؟",
    quickQuestion3: "كيف أودع؟",
    quickQuestion4: "هل المنصة آمنة؟",
  },
  
  // Language names
  languages: {
    ar: "العربية",
    en: "English",
    es: "Español",
    de: "Deutsch",
    zh: "中文",
    ja: "日本語",
    he: "עברית",
  },
};

export default ar;
